import { TranslationsContext } from '@telia-common-components/shared';
import * as React from 'react';
import { Notice } from 'telia-front-react';
import { FetchStatus } from '../../../../util/FetchStatus';
import { useInternetNotices } from '../InternetNoticesProvider';
import { useInternetCalculator } from '../InternetCalculatorProvider';
const MissingMandateNotice = () => {
    const translate = React.useContext(TranslationsContext).translate;
    const { hasLegalOrServiceMandateState } = useInternetNotices();
    const { isSecureNet } = useInternetCalculator();
    const errorKey = hasLegalOrServiceMandateState.status === FetchStatus.ERROR ? 'failedToLoadMandates' : 'legalOrServiceMandateMissing';
    return React.createElement(Notice, { type: "error" }, translate(isSecureNet ? `secureNetCalculator.${errorKey}` : `internetCalculator.${errorKey}`));
};
export default MissingMandateNotice;
